import React from 'react'
import Spinner from '../Spinner'
import styles from './styles.module.css'

const Button = ({ isLoading, loadingLabel, children, className, ...props }) => {
  const LoadingComponent = () => {
    if(!loadingLabel) return <Spinner />
    return ( <><Spinner className={styles.buttonWithSpinner}/>{loadingLabel}</>)
  }

  return (
    <button className={`${styles.button} ${className}`} disabled={isLoading} {...props}>
      {isLoading ? <LoadingComponent /> : children}
    </button>
  )
}

export default Button
